import { CustomRequest, Customer, RequestMethods } from "@ecountabl/lib";
import React from "react"

type Props = {
  onChange: (CustomProduct) => void;
  customer: Partial<Customer>;
}

const CustomProductEditor = ({onChange, customer}:Props) => {
  
  return (
    <div className="customer-editor-grid-section">
      <h4>Custom Product</h4>
      <div className="customer-editor-grid">
        <label>Product Name</label>
        <input
          type="text"
          className="form-control"
          value={customer.customProduct?.name || ""}
          onChange={(e) => {
            onChange({...customer.customProduct, name: e.target.value})
          }}
          placeholder="Product Name"
        />
        <label>APY (%)</label>
        <input
          type="number"
          className="form-control"
          value={customer.customProduct?.apy || ""}
          onChange={(e) => {
            onChange({...customer.customProduct, apy: parseFloat(e.target.value)})
          }}
          placeholder="Interest Rate"
        />
        <label>Product Recommendation</label>
          <textarea
            className="form-control"
            value={customer.customProduct?.messaging?.recommendation || ""}
            onChange={(e) => {
              onChange({
                ...customer.customProduct,
                messaging: {
                  ...customer.customProduct?.messaging,
                  recommendation: e.target.value
              }})
            }}
            placeholder="We now offer ..."
          />
          <label>Reqs to Get High Rate</label>
          <textarea
            className="form-control"
            value={customer.customProduct?.messaging?.requirementsToEarnHighInterest || ""}
            onChange={(e) => {
              onChange({
                ...customer.customProduct,
                messaging: {
                  ...customer.customProduct?.messaging,
                  requirementsToEarnHighInterest: e.target.value
              }})
            }}
            placeholder="Must have ... to get high interest"
          />
          <label>Reqs to Keep High Rate</label>
          <textarea
            className="form-control"
            value={customer.customProduct?.messaging?.requirementsToKeepHighInterest || ""}
            onChange={(e) => {
              onChange({
                ...customer.customProduct,
                messaging: {
                  ...customer.customProduct?.messaging,
                  requirementsToKeepHighInterest: e.target.value
              }})
            }}
            placeholder="Must have ... to keep high interest"
          />
          <label style={{alignSelf: "flex-start"}}>Class Codes</label>
          <div className="class-codes">
            {
              customer.customProduct?.classCodes?.map((classCode, index) => (
                <div key={index} className="customer-editor-grid">
                  <input
                    type="number"
                    className="form-control"
                    value={classCode}
                    onChange={(e) => {
                      const classCodes = [...customer.customProduct?.classCodes || []]
                      classCodes[index] = parseFloat(e.target.value)
                      onChange({...customer.customProduct, classCodes})
                    }}
                    placeholder="Class Code"
                    onWheel={ event => event.currentTarget.blur() }
                  />
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => {
                      const classCodes = [...customer.customProduct?.classCodes || []]
                      classCodes.splice(index, 1)
                      onChange({...customer.customProduct, classCodes})
                    }}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              ))
            }
            <button
              type="button"
              className="btn btn-normal"
              onClick={() => {
                const classCodes = [...customer.customProduct?.classCodes || []]
                classCodes.push(0)
                onChange({...customer.customProduct, classCodes})
              }}
            >
              <i className="fa fa-plus-circle" />
            </button>
          </div>
      </div>
    </div>
  )
}

export default CustomProductEditor